import { Outlet, createFileRoute } from "@tanstack/react-router";
import { Layout } from "antd";

const { Content } = Layout;

export const Route = createFileRoute("/$tenantSlug/processes/_layout")({
    component: ProcessLayoutComponent,
});

function ProcessLayoutComponent() {
    return (
        <Layout className={"bg-[#000000] overflow-y-scroll"}>
            <Content className={"m-5"}>
                <div className="flex flex-1 justify-center items-center h-full">
                    <main className="">
                        <Outlet />
                    </main>
                </div>
            </Content>
        </Layout>
    );
}
